var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"0","margin-left":"0","height":"1100px","margin-top":"0px","width":"100%"},attrs:{"scrolling":"no","src":_vm.manualizeURL}})}
var staticRenderFns = []

export { render, staticRenderFns }